import { Icons } from 'ui/atoms/Icon/Icon';
import { VisitorGroupType } from 'utils/VisitorGroup/VisitorGroup';

const getVisitorGroupIcon = (groupType: VisitorGroupType): Icons => {
  switch (groupType) {
    case VisitorGroupType.AzureAd:
      return 'ADSyncedUser';
    case VisitorGroupType.ExternalVisitors:
      return 'Visitor';
    case VisitorGroupType.Installers:
      return 'Installers';
    case VisitorGroupType.CoContractors:
    default:
      return 'CoContractor';
  }
};

export default { getVisitorGroupIcon };
